<mat-table #table [dataSource]="dataSource" class="aopa-mat-table edit-business-hours__table">

  <ng-container matColumnDef="fromMmDd">
    <mat-header-cell *matHeaderCellDef class="mat-header-cell hours_fromMMdd">From Date</mat-header-cell>
    <mat-cell *matCellDef="let hour" class="mat-cell hours_fromMMdd">
      <mat-form-field class="hour-mat-form-field" floatLabel="{{ hour.editing ? 'float' : 'never'}}">
        <input matInput [formControl]="hour.validator.controls['From Date']" [(ngModel)]="hour.currentData.fromMmDd"
          type="datetime" placeholder="From Date (mm/dd)">
      </mat-form-field>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="toMmDd">
    <mat-header-cell *matHeaderCellDef class="mat-header-cell hours_toMmDd">To Date</mat-header-cell>
    <mat-cell *matCellDef="let hour" class="mat-cell hours_toMmDd">
      <mat-form-field class="hour-mat-form-field" floatLabel="{{ hour.editing ? 'float' : 'never'}}">
        <input matInput [formControl]="hour.validator.controls['To Date']" [(ngModel)]="hour.currentData.toMmDd" type="datetime"
          placeholder="To Date (mm/dd)">
      </mat-form-field>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="fromWeekDay">
    <mat-header-cell *matHeaderCellDef class="mat-header-cell hours_fromWeekDay">From Day</mat-header-cell>
    <mat-cell *matCellDef="let hour" class="mat-cell hours_fromWeekDay">
      <mat-form-field class="hour-mat-form-field">
        <mat-select [(ngModel)]="hour.currentData.fromWeekDay" name="From Day" [formControl]="hour.validator.controls['From Day']"
          placeholder="From Day of Week">
          <mat-option *ngFor="let day of daysOfTheWeek" [value]="day">
            {{day}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="toWeekDay">
    <mat-header-cell *matHeaderCellDef class="mat-header-cell hours_toWeekDay">To Day</mat-header-cell>
    <mat-cell *matCellDef="let hour" class="mat-cell hours_toWeekDay">
      <mat-form-field class="hour-mat-form-field">
        <mat-select [(ngModel)]="hour.currentData.toWeekDay" name="To Day" [formControl]="hour.validator.controls['To Day']"
          placeholder="To Day of Week">
          <mat-option *ngFor="let day of daysOfTheWeek" [value]="day">
            {{day}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="fromTime">
    <mat-header-cell *matHeaderCellDef class="mat-header-cell hours_fromTime">From Time</mat-header-cell>
    <mat-cell *matCellDef="let hour" class="mat-cell hours_fromTime">
      <mat-form-field class="hour-mat-form-field-long">
        <mat-select [(ngModel)]="hour.currentData.fromTime" name="From Time" [formControl]="hour.validator.controls['From Time']"
                    placeholder="Choose open time">
          <mat-option value="Dawn">Dawn</mat-option>
          <mat-option value="00:00">12:00 AM</mat-option>
          <mat-option value="00:30">12:30 AM</mat-option>
          <mat-option value="01:00">01:00 AM</mat-option>
          <mat-option value="01:30">01:30 AM</mat-option>
          <mat-option value="02:00">02:00 AM</mat-option>
          <mat-option value="02:30">02:30 AM</mat-option>
          <mat-option value="03:00">03:00 AM</mat-option>
          <mat-option value="03:30">03:30 AM</mat-option>
          <mat-option value="04:00">04:00 AM</mat-option>
          <mat-option value="04:30">04:30 AM</mat-option>
          <mat-option value="05:00">05:00 AM</mat-option>
          <mat-option value="05:30">05:30 AM</mat-option>
          <mat-option value="06:00">06:00 AM</mat-option>
          <mat-option value="06:30">06:30 AM</mat-option>
          <mat-option value="07:00">07:00 AM</mat-option>
          <mat-option value="07:30">07:30 AM</mat-option>
          <mat-option value="08:00">08:00 AM</mat-option>
          <mat-option value="08:30">08:30 AM</mat-option>
          <mat-option value="09:00">09:00 AM</mat-option>
          <mat-option value="09:30">09:30 AM</mat-option>
          <mat-option value="10:00">10:00 AM</mat-option>
          <mat-option value="10:30">10:30 AM</mat-option>
          <mat-option value="11:00">11:00 AM</mat-option>
          <mat-option value="11:30">11:30 AM</mat-option>
          <mat-option value="12:00">12:00 PM</mat-option>
          <mat-option value="12:30">12:30 PM</mat-option>
          <mat-option value="13:00">01:00 PM</mat-option>
          <mat-option value="13:30">01:30 PM</mat-option>
          <mat-option value="14:00">02:00 PM</mat-option>
          <mat-option value="14:30">02:30 PM</mat-option>
          <mat-option value="15:00">03:00 PM</mat-option>
          <mat-option value="15:30">03:30 PM</mat-option>
          <mat-option value="16:00">04:00 PM</mat-option>
          <mat-option value="16:30">04:30 PM</mat-option>
          <mat-option value="17:00">05:00 PM</mat-option>
          <mat-option value="17:30">05:30 PM</mat-option>
          <mat-option value="18:00">06:00 PM</mat-option>
          <mat-option value="18:30">06:30 PM</mat-option>
          <mat-option value="19:00">07:00 PM</mat-option>
          <mat-option value="19:30">07:30 PM</mat-option>
          <mat-option value="20:00">08:00 PM</mat-option>
          <mat-option value="20:30">08:30 PM</mat-option>
          <mat-option value="21:00">09:00 PM</mat-option>
          <mat-option value="21:30">09:30 PM</mat-option>
          <mat-option value="22:00">10:00 PM</mat-option>
          <mat-option value="22:30">10:30 PM</mat-option>
          <mat-option value="23:00">11:00 PM</mat-option>
          <mat-option value="23:30">11:30 PM</mat-option>
        </mat-select>
        <!-- <input matInput [formControl]="hour.validator.controls['From Time']" [(ngModel)]="hour.currentData.fromTime"
          type="time" [attr.disabled]="hour.currentData.fromDawn?'':null"> -->
      </mat-form-field>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="toTime">
    <mat-header-cell *matHeaderCellDef class="mat-header-cell hours_toTime">To Time</mat-header-cell>
    <mat-cell *matCellDef="let hour" class="mat-cell hours_toTime">
      <mat-form-field class="hour-mat-form-field-long">
        <mat-select [(ngModel)]="hour.currentData.toTime" name="To Time" [formControl]="hour.validator.controls['To Time']"
                    placeholder="Choose close time">
          <mat-option value="Dusk">Dusk</mat-option>
          <mat-option value="00:00">12:00 AM</mat-option>
          <mat-option value="00:30">12:30 AM</mat-option>
          <mat-option value="01:00">01:00 AM</mat-option>
          <mat-option value="01:30">01:30 AM</mat-option>
          <mat-option value="02:00">02:00 AM</mat-option>
          <mat-option value="02:30">02:30 AM</mat-option>
          <mat-option value="03:00">03:00 AM</mat-option>
          <mat-option value="03:30">03:30 AM</mat-option>
          <mat-option value="04:00">04:00 AM</mat-option>
          <mat-option value="04:30">04:30 AM</mat-option>
          <mat-option value="05:00">05:00 AM</mat-option>
          <mat-option value="05:30">05:30 AM</mat-option>
          <mat-option value="06:00">06:00 AM</mat-option>
          <mat-option value="06:30">06:30 AM</mat-option>
          <mat-option value="07:00">07:00 AM</mat-option>
          <mat-option value="07:30">07:30 AM</mat-option>
          <mat-option value="08:00">08:00 AM</mat-option>
          <mat-option value="08:30">08:30 AM</mat-option>
          <mat-option value="09:00">09:00 AM</mat-option>
          <mat-option value="09:30">09:30 AM</mat-option>
          <mat-option value="10:00">10:00 AM</mat-option>
          <mat-option value="10:30">10:30 AM</mat-option>
          <mat-option value="11:00">11:00 AM</mat-option>
          <mat-option value="11:30">11:30 AM</mat-option>
          <mat-option value="12:00">12:00 PM</mat-option>
          <mat-option value="12:30">12:30 PM</mat-option>
          <mat-option value="13:00">01:00 PM</mat-option>
          <mat-option value="13:30">01:30 PM</mat-option>
          <mat-option value="14:00">02:00 PM</mat-option>
          <mat-option value="14:30">02:30 PM</mat-option>
          <mat-option value="15:00">03:00 PM</mat-option>
          <mat-option value="15:30">03:30 PM</mat-option>
          <mat-option value="16:00">04:00 PM</mat-option>
          <mat-option value="16:30">04:30 PM</mat-option>
          <mat-option value="17:00">05:00 PM</mat-option>
          <mat-option value="17:30">05:30 PM</mat-option>
          <mat-option value="18:00">06:00 PM</mat-option>
          <mat-option value="18:30">06:30 PM</mat-option>
          <mat-option value="19:00">07:00 PM</mat-option>
          <mat-option value="19:30">07:30 PM</mat-option>
          <mat-option value="20:00">08:00 PM</mat-option>
          <mat-option value="20:30">08:30 PM</mat-option>
          <mat-option value="21:00">09:00 PM</mat-option>
          <mat-option value="21:30">09:30 PM</mat-option>
          <mat-option value="22:00">10:00 PM</mat-option>
          <mat-option value="22:30">10:30 PM</mat-option>
          <mat-option value="23:00">11:00 PM</mat-option>
          <mat-option value="23:30">11:30 PM</mat-option>
          <mat-option value="23:59">11:59 PM</mat-option>
        </mat-select>
      </mat-form-field>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actionsCol">
    <mat-header-cell *matHeaderCellDef>
      <button mat-icon-button color="accent" (click)="addNewRow()" matTooltip="Add Row"><i class="fa fa-plus mat-icon"></i>
      </button>
    </mat-header-cell>
    <mat-cell *matCellDef="let hour">
      <button *ngIf="!hour.editing" mat-icon-button color="primary" focusable="false" (click)="startEdit(hour)"
        matTooltip="Edit">
        <i class="fa fa-pencil mat-icon"></i>
      </button>
      <button *ngIf="hour.editing" mat-icon-button color="primary" focusable="false" (click)="confirmEditOrCreate(hour)"
        matTooltip="Confirm">
        <i class="fa fa-floppy-o mat-icon"></i>
      </button>
      <button *ngIf="hour.editing" mat-icon-button color="primary" focusable="false" (click)="cancelOrDelete(hour)"
        matTooltip="Cancel">
        <i class="fa fa-times mat-icon"></i>
      </button>
      <button *ngIf="!hour.editing" mat-icon-button color="primary" focusable="false" (click)="cancelOrDelete(hour)"
        matTooltip="Delete">
        <i class="fa fa-trash mat-icon"></i>
      </button>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayCols;"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayCols;"></mat-row>
</mat-table>
